import {IncomingHttpHeaders} from 'http';

import {AssessmentAttemptsCheckQuery, useAssessmentAttemptsCheckQuery} from 'src/generated/graphql';

import {getPassThroughHeaders} from './fetch-utils';

export type AssessmentAttemptsSummaries =
    AssessmentAttemptsCheckQuery['assessmentAttemptsSummaries'];

/**
 * Fetches assessment attempt summaries to check if the user has started any assessment.
 * Used server-side to gate the assessments banner on LIHP.
 * Returns null on failure so the banner fails open (shows rather than permanently hides).
 */
export const fetchAssessmentAttempts = async (
    requestHeaders: IncomingHttpHeaders,
): Promise<AssessmentAttemptsSummaries> => {
    try {
        const response = await useAssessmentAttemptsCheckQuery.fetcher(
            {},
            getPassThroughHeaders(requestHeaders),
        )();
        return response?.assessmentAttemptsSummaries ?? null;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('[fetchAssessmentAttempts] failed:', error);
        return null;
    }
};

export const hasStartedAnyAssessment = (summaries: AssessmentAttemptsSummaries): boolean => {
    return Boolean(
        summaries?.some((summary) => summary?.attempts?.some((attempt) => attempt?.startTime)),
    );
};
